
import { Component, Vue } from 'vue-property-decorator';
import { SalesQuote, SapProduct } from '@/api';
import SelectProductGroup from '@/components/orders/SelectProductGroup.vue';
import { ProductGroup } from '@/store/OrderStore';
import ProductSearchBar from '@/components/orders/ProductSearchBar.vue';

@Component({
  components: { ProductSearchBar, SelectProductGroup },
})
export default class NewClaimProductSelect extends Vue {
  get agreement(): SalesQuote {
    return this.$store.getters['claim/agreement'];
  }

  get products(): SapProduct[] {
    return this.$store.getters['claim/productSearchResult'];
  }

  get groups(): ProductGroup[] {
    return this.$store.getters['claim/agreementProductGroups'](true);
  }

  get groupLabels(): string[] {
    const all = Object.keys(this.groups);
    const filter = this.$store.state.claim.products.filterGroups;
    if (filter.size === 0) {
      return all;
    }
    return all.filter((group) => filter.has(group));
  }
}
